import { z } from "zod/v4";

import {
  PauseCancelReasonDtoSchema,
  SubscriptionCollectionMethodList,
} from "../../../dtos/subscriptions";
import { StripeProductVersionList } from "../../../schemas/stripe";

const BaseAdjustBillingRequestBodySchema = z.object({
  action: z.enum(["pause", "cancel", "reactivate", "modify", "create"]),
});

export const CreateBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    version: z.enum(StripeProductVersionList),
    action: z.literal("create"),
    couponId: z.string().nullish(),
    priceIds: z.string().array(),
    collectionMethod: z.enum(SubscriptionCollectionMethodList).nullish(),
  });

export type CreateBillingRequestBodyType = z.infer<
  typeof CreateBillingRequestBodySchema
>;

export const PauseBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    stripeSubscriptionLinkId: z.uuid(),
    action: z.literal("pause"),
    reasons: PauseCancelReasonDtoSchema.array(),
    returnDate: z.number().nullish(),
    comments: z.string().nullish(),
  });

export const CancelBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    stripeSubscriptionLinkId: z.uuid(),
    action: z.literal("cancel"),
    reasons: PauseCancelReasonDtoSchema.array(),
    returnDate: z.number().nullish(),
    comments: z.string().nullish(),
  });

export const UpgradeBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    version: z.enum(StripeProductVersionList),
    stripeSubscriptionLinkId: z.string().uuid(),
    couponId: z.string().nullish(),
    action: z.literal("upgrade"),
    priceIds: z.string().array(),
  });

export type UpgradeBillingRequestBodyType = z.infer<
  typeof UpgradeBillingRequestBodySchema
>;

export const DowngradeBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    version: z.enum(StripeProductVersionList),
    stripeSubscriptionLinkId: z.string().uuid(),
    couponId: z.string().nullish(),
    action: z.literal("downgrade"),
    priceIds: z.string().array(),
  });

export type DowngradeBillingRequestBodyType = z.infer<
  typeof DowngradeBillingRequestBodySchema
>;

export const ReactivateBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    stripeSubscriptionLinkId: z.uuid(),
    action: z.literal("reactivate"),
  });

export const ReleaseBillingRequestBodySchema =
  BaseAdjustBillingRequestBodySchema.extend({
    stripeSubscriptionLinkId: z.uuid(),
    action: z.literal("release"),
  });

export const AdjustBillingRequestBodySchema = z.discriminatedUnion("action", [
  CreateBillingRequestBodySchema,
  PauseBillingRequestBodySchema,
  CancelBillingRequestBodySchema,
  UpgradeBillingRequestBodySchema,
  DowngradeBillingRequestBodySchema,
  ReactivateBillingRequestBodySchema,
  ReleaseBillingRequestBodySchema,
]);

export type AdjustBillingRequestBodyType = z.infer<
  typeof AdjustBillingRequestBodySchema
>;

export const AdjustBillingResponseBodySchema = z.string();
export type AdjustBillingResponseBodyType = z.infer<
  typeof AdjustBillingResponseBodySchema
>;
